import { useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import { useExportContext } from "../../context/export.context";
import { DocumentType } from "../../utils/export.util";
import { useUserContext } from "../../context/user.context";
import { useNavigate } from "react-router-dom";
import { useDevices } from "../../hooks/useDevices";

export const ExportTable = ({ children, tableData }) => {
  const { downloadFile, exportFlag } = useExportContext();
  const { roleCanExport } = useUserContext();

  const defaultChoice = {
    value: DocumentType.CSV,
    label: DocumentType.CSV,
  };

  const [selectedExportType, setFormatChoice] = useState(defaultChoice);

  const { t } = useTranslation();
  let exportFormats = [DocumentType.CSV, DocumentType.PDF, DocumentType.EXCEL];

  const exportOptions = exportFormats.map((item) => ({
    value: item,
    label: `${item}`,
  }));

  const handleFormatChange = (selected) => {
    setFormatChoice(selected);
  };

  const handleClick = () => {
    downloadFile(selectedExportType?.value, tableData);
  };

  return (
    <>
      {/* <Row>
        <Col xs={1} sm={7} md={7} lg={7} xl={7} xxl={7}></Col>
        <Col xs={10} sm={3} md={3} lg={3} xl={4} xxl={4} className="mg-b-5">
          <ReactSelect
            classNamePrefix="Select2"
            closeMenuOnSelect={true}
            value={selectedExportType}
            onChange={handleFormatChange}
            placeholder={t("devices.exportChoice")}
            isMulti={false}
            options={exportOptions}
          />
        </Col>
        <Col xs={8} sm={2} md={2} lg={2} xl={1} xxl={1} className="float-none">
          <Button className="float-end" onClick={handleClick}>
            {t("devices.Export")}
          </Button>
        </Col>
      </Row> */}
      <Row>
        {/* EXPORT */}
        <Col>
          <Button className="wd-150 float-end mg-x-5 mg-b-5" onClick={handleClick} disabled={!roleCanExport}>
            {exportFlag ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> {t("general.Spinners.Exporting")}
              </>
            ) : (
              t("general.Export")
            )}
          </Button>

          <ReactSelect
            className="wd-150 float-end mg-x-5"
            classNamePrefix="Select2"
            closeMenuOnSelect={true}
            value={selectedExportType}
            onChange={handleFormatChange}
            placeholder={t("devices.exportChoice")}
            isMulti={false}
            options={exportOptions}
          />
        </Col>
      </Row>

      {/* FILTER SEARCH */}
      <Row>
        <Col>
          {/* <Form.Control
                        placeholder="Filter table"
                        type="text"
                        onChange={(event) => handleSearchText(event)}
                        value={searchValue}
                    >
                    </Form.Control> */}

          {children}
        </Col>
      </Row>
    </>
  );
};
